export default "__VITE_ASSET__B38R155P__"